import { http } from './http'

export interface ICampaignTicket {
  id: string
  name: string
  price: number
  ticketCategoryId: string
  ticketCategoryName: string
}

export interface ICampaign {
  id: string
  name: string
  url: string
  passwordProtected: boolean
  password: string
  onlyForLoyalUsers: boolean
  onlyForLoggedInUsers: boolean
  active: boolean
  deepLinkUrl: string
  webUrl: string
  mobileUrl: string
  tickets: ICampaignTicket[]
}

export interface ICampaignPayload {
  name: string
  url: string
  passwordProtected: boolean
  password: string
  onlyForLoyalUsers: boolean
  onlyForLoggedInUsers: boolean
  active: boolean
}

export const getCampaign = (campaignId: string) =>
  http.get<ICampaign>(`/operations/campaign/${campaignId}`)

export const createCampaign = (campaign: ICampaignPayload) =>
  http.post<ICampaign>(`/operations/campaign`, campaign)

export const updateCampaign = (
  campaignId: string,
  campaign: ICampaignPayload,
) => http.put<ICampaign>(`/operations/campaign/${campaignId}`, campaign)

export const deleteCampaign = (campaignId: string) =>
  http.delete<ICampaign>(`/operations/campaign/${campaignId}`)

export const getCampaigns = () => http.get<ICampaign[]>(`/operations/campaign`)
